import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Header from './components/Header/Header';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Footer from './components/Footer/Footer';
import HomePage from './components/HomePage/HomePage';
import AboutPage from './pages/AboutPage/AboutPage';
import ProgramsPage from './pages/ProgramsPage/ProgramsPage';
import AdmissionsPage from './pages/AdmissionsPage/AdmissionsPage';
import ResourcesPage from './pages/ResourcesPage/ResourcesPage';
import ContactPage from './pages/ContactPage/ContactPage';
import FAQPage from './pages/FAQPage/FAQPage';
import NewsCalendarPage from './pages/NewsCalendarPage/NewsCalendarPage';
import PublicAnnouncementPage from './pages/AnnouncementsPage/PublicAnnouncementPage';
import PublicEventPage from './pages/EventsPage/PublicEventPage';
import PublicScheduledClosingPage from './pages/ScheduledClosingsPage/PublicScheduledClosingPage';
import HealthSafetyPage from './pages/HealthSafetyPage/HealthSafetyPage';
import GalleryPage from './pages/GalleryPage/GalleryPage';
import GalleryCategoryPage from './pages/GalleryPage/GalleryCategoryPage';
import AdminSignIn from './pages/Admin/AdminSignIn';
import AdminLayout from './pages/Admin/AdminLayout';
import ProgramsList from './pages/Admin/Programs/ProgramsList';
import ProgramForm from './pages/Admin/Programs/ProgramForm';
import ProgramView from './pages/Admin/Programs/ProgramView';
import InquiryList from './pages/Admin/Inquiries/InquiryList';
import InquiryView from './pages/Admin/Inquiries/InquiryView';
import BookingList from './pages/Admin/Bookings/BookingList';
import BookingView from './pages/Admin/Bookings/BookingView';
import ContactList from './pages/Admin/Contacts/ContactList';
import ContactView from './pages/Admin/Contacts/ContactView';
import TestimonialsList from './pages/Admin/Testimonials/TestimonialsList';
import TestimonialView from './pages/Admin/Testimonials/TestimonialView';
import GalleriesList from './pages/Admin/Galleries/GalleriesList';
import GalleryView from './pages/Admin/Galleries/GalleryView';
import AnnouncementsList from './pages/Admin/Announcements/AnnouncementsList';
import AnnouncementView from './pages/Admin/Announcements/AnnouncementView';
import EventsList from './pages/Admin/Events/EventsList';
import EventView from './pages/Admin/Events/EventView';
import ScheduledClosingsList from './pages/Admin/ScheduledClosings/ScheduledClosingsList';
import ScheduledClosingView from './pages/Admin/ScheduledClosings/ScheduledClosingView';
import './App.css';

function PublicLayout() {
  return (
    <div className="app">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/admissions" element={<AdmissionsPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/news-calendar" element={<NewsCalendarPage />} />
          <Route path="/announcements/:id" element={<PublicAnnouncementPage />} />
          <Route path="/events/:id" element={<PublicEventPage />} />
          <Route path="/scheduled-closings/:id" element={<PublicScheduledClosingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/health-safety" element={<HealthSafetyPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/gallery/:id" element={<GalleryCategoryPage />} />
        </Route>
        {/* Admin Signin */}
        <Route path="/admin/signin" element={<AdminSignIn />} />
        {/* Admin Dashboard */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="programs" replace />} />
          <Route path="programs" element={<ProgramsList />} />
          <Route path="programs/new" element={<ProgramForm />} />
          <Route path="programs/:id" element={<ProgramView />} />
          <Route path="inquiries" element={<InquiryList />} />
          <Route path="inquiries/:id" element={<InquiryView />} />
          <Route path="bookings" element={<BookingList />} />
          <Route path="bookings/:id" element={<BookingView />} />
          <Route path="contacts" element={<ContactList />} />
          <Route path="contacts/:id" element={<ContactView />} />
          <Route path="testimonials" element={<TestimonialsList />} />
          <Route path="testimonials/:id" element={<TestimonialView />} />
          <Route path="galleries" element={<GalleriesList />} />
          <Route path="galleries/:id" element={<GalleryView />} />
          <Route path="announcements" element={<AnnouncementsList />} />
          <Route path="announcements/:id" element={<AnnouncementView />} />
          <Route path="events" element={<EventsList />} />
          <Route path="events/:id" element={<EventView />} />
          <Route path="scheduled-closings" element={<ScheduledClosingsList />} />
          <Route path="scheduled-closings/:id" element={<ScheduledClosingView />} />
        </Route>
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;